<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";
import authHeader from "./services/auth-header";
import baseUrl from "./services/base-url"

export default {
  name: 'App',
  watch:{
    $route (to, from){
      
    }
  },
  methods : {
    check() {
      axios
        .get(baseUrl()+"/api/all/check-auth", {
          headers: authHeader()
        })
        .then(() => {
          return true;
        })
        .catch(() => {
        
          this.$router.push({ name: "Login" });
          this.$store.dispatch("auth/logout");
        });
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
